import React from 'react';
import './HistoryComp.css';

const historyEvents = [
  {
    year: '1985',
    title: 'Founded DEI Engineering',
    description:
      'Dhillon Engineering Inc. is founded by Gurmeet Dhillon and begins as a civil and structural engineering firm.',
  },
  {
    year: '1990',
    title: 'MEP Work',
    description: 'Mechanical, Electrical, and Plumbing (MEP) design work begins.',
  },
  {
    year: '1998',
    title: 'Architecture Work',
    description: 'Architectural engineering design work begins.',
  },
  {
    year: '2000',
    title: 'Office Expansion',
    description: 'Dhillon Engineering Inc. office is expanded to accommodate more employees.',
  },
  {
    year: '2010',
    title: '25th Anniversary ',
    description: 'Dhillon Engineering Inc. celebrates its 25th anniversary.',
  },
  {
    year: '2025',
    title: '40th Anniversary ',
    description:
      'Dhillon Engineering Inc. celebrates 40 years of accomplishments.',
  },
];

export default function History() {
  return (
    <section className="history-container">
      <h1 className="history-title">Our History</h1>
      <div className="history-timeline">
        {historyEvents.map((event, idx) => (
          <div className="event-item" key={idx}>
            <div className="event-marker">
              <span className="marker-dot"></span>
              <span className="marker-year">{event.year}</span>
            </div>
            <div className="event-content">
              <h3 className="event-title">{event.title}</h3>
              <p className="event-description">{event.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
